<header class="main-header" id="header">


  <nav class="navbar navbar-expand-lg navbar-light" [style]="getBackgroundStyle()" id="navbar">

    <!-- Sidebar toggle button -->
    <button id="sidebar-toggler" class="sidebar-toggle" (click)="toggleNavigation()">
      <span class="visually-hidden">Toggle navigation</span>
    </button>

    <span class="page-title">{{pageTitle | translate}}</span>

    <div class="navbar-right ">

      <ul class="nav navbar-nav">

        <!-- Data Archiving dropdown-->

        @if (hasArchiveDB) {
          <li class="dropdown data-menu">
            <button href="#" class="dropdown-toggle nav-link" data-bs-toggle="dropdown" [ngClass]="isArchiveMode ? 'dropdown-archive' : 'dropdown-live' ">
              @if (isArchiveMode) {
                <span class="d-none d-lg-inline-block">{{ 'T4.PAGE-HEADER.ARCHIVEUNTIL' | translate }} {{archiveDates[1]}})</span>
              }
              @if (!isArchiveMode) {
                <span class="d-none d-lg-inline-block">{{ 'T4.PAGE-HEADER.LIVE' | translate }}</span>
              }
            </button>
            <ul class="dropdown-menu dropdown-menu-end clickable">
              <li class="dropdown-menu__item clickable">
                <a class="dropdown-link-item" (click)="setArchiveMode(false)">
                  @if (showArchiveDates()) {
                    <span class="nav-text">{{ 'T4.PAGE-HEADER.LIVEFROM' | translate }} {{archiveDates[0]}}</span>
                  }
                  @if (!showArchiveDates()) {
                    <span class="nav-text">{{ 'T4.PAGE-HEADER.LIVE' | translate }}</span>
                  }
                </a>
              </li>
              <li class="dropdown-menu__item clickable">
                <a class="dropdown-link-item" (click)="setArchiveMode(true)">
                  @if (showArchiveDates()) {
                    <span class="nav-text">{{ 'T4.PAGE-HEADER.ARCHIVEUNTIL' | translate }} {{archiveDates[1]}}</span>
                  }
                  @if (!showArchiveDates()) {
                    <span class="nav-text">{{ 'T4.PAGE-HEADER.ARCHIVE' | translate }}</span>
                  }
                </a>
              </li>
            </ul>
          </li>
        }


        <!-- Offcanvas -->

        <!-- Message Center -->
        @if (hasNotificationService) {
          <div>
            <li class="dropdown custom-dropdown">
              <button (click)="toggleNotificationCenter()" class="notify-toggler custom-dropdown-toggler">
                <i class="mdi mdi-bell-outline icon"></i>
                @if (newNotifications > 0) {
                  <span class="badge badge-xs rounded-circle">{{ newNotifications }}</span>
                }
              </button>
              @if (notificationCenterVisible) {
                <div class="dropdown-notify">
                  @if (notificationsToDisplay != null && notificationsToDisplay.NotificationsPerType.length == 0) {
                    <div class="notification-center-body">
                      <div style="height: 325px;" class="media media-sm p-4 bg-light mb-0">
                        <div class="media-body" style="padding-top: 120px; text-align:center;">
                          <i style="font-size: 22px;" class="fa fa-bell-o" aria-hidden="true"></i>
                          <span class="title mb-0">{{ 'NOTIFICATIONCENTER.NOMESSAGES' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <header>
                      <div class="nav nav-underline" id="nav-tab" role="tablist">
                        @for (type of notificationsToDisplay.NotificationsPerType; track type) {
                          <a (click)="selectType(type)" [class.active]="selectedTypeId == type.Id" class="nav-item nav-link"role="tab">
                            {{ type.TranslationCode | translate }} ({{type.Notifications.length}})
                          </a>
                        }
                        <!-- <a class="nav-item nav-link active" id="all-tabs" data-bs-toggle="tab" href="#all" role="tab" aria-controls="nav-home" aria-selected="true">All (5)</a>
                        <a class="nav-item nav-link" id="message-tab" data-bs-toggle="tab" href="#message" role="tab" aria-controls="nav-profile" aria-selected="false">Msgs (4)</a>
                        <a class="nav-item nav-link" id="other-tab" data-bs-toggle="tab" href="#other" role="tab" aria-controls="nav-contact" aria-selected="false">Others (3)</a> -->
                      </div>
                    </header>
                    @for (type of notificationsToDisplay.NotificationsPerType; track type) {
                      <div [class.d-none]="selectedTypeId !== type.Id" class="notification-center-body">
                        @for (notification of type.Notifications; track notification) {
                          <div class="media media-sm p-4 bg-light mb-0">
                            @if (notification.LongRunningOperationId === null) {
                              <span style="height: 64px; width: 64px; font-size: 32px; color: #487EBC"  class="mdi mdi-information-outline"></span>
                              <div class="media-body">
                                <a href="#">
                                  <span class="title mb-0">{{ notification.TranslationCode | translate}}</span>
                                  <span class="discribe">{{ notification.DetailText | replaceOnEmpty }}</span>
                                  <span class="time">
                                    <time>{{ notification.Created | localDateTime }}</time>...
                                  </span>
                                </a>
                              </div>
                            } @else {
                              @if (notification.LROIsPending) {
                                <div class="d-flex align-items-center justify-content-center spin-holder" style="height: 64px;">
                                  <div class="sk-circle sk-circle-small">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                  </div>
                                </div>
                              }
                              @if (notification.NotificationStatusCode == 'Succeeded') {
                                <span class="lro-notify lro-done">
                                  <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </span>
                              }
                              @if (notification.NotificationStatusCode == 'Errored') {
                                <span class="lro-notify lro-danger">
                                  <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                </span>
                              }
                              @if (notification.NotificationStatusCode == 'Canceled') {
                                <span class="lro-notify lro-warning">
                                  <i class="fa fa-ban" aria-hidden="true"></i>
                                </span>
                              }
                              <div class="media-body">
                                <span class="title mb-0">{{ notification.TranslationCode | translate }}</span>
                                <span class="discribe">{{ notification.ProgressPercentage }}% - {{ getDetailText(notification) | replaceOnEmpty | translate }}</span>
                                @if (canCancel(notification)) {
                                  <div>
                                    <button (click)="cancelLRO(notification.LongRunningOperationId)">{{ 'LRO.CANCEL' | translate }}</button>
                                  </div>
                                }
                                @if (notification.HasAttachment) {
                                  <div>
                                    <button (click)="downloadAttachment(notification.NotificationId)">{{ 'LRO.DOWNLOAD_ATTACHMENT' | translate }}</button>
                                  </div>
                                }
                                @if (notification.AllowsContinuation) {
                                  <div>
                                    <button (click)="createContinuation(notification.NotificationId)">{{ 'LRO.START-CONTINUATION' | translate }}</button>
                                  </div>
                                }
                                @if (notification.HasAdditionalData) {
                                  <div>
                                    <button (click)="showAdditionalInformation(notification.NotificationId)">{{ 'LRO.SHOWMORE' | translate }}</button>
                                  </div>
                                }
                              </div>
                            }
                            <!-- START OF LRO TEMPLATE -->
                          </div>
                        }
                      </div>
                    }
                    <footer class="border-top dropdown-notify-footer">
                      <div class="d-flex justify-content-between align-items-center py-2 px-4">
                        <span>{{ 'NOTIFICATIONCENTER.LASTUPDATED' | translate }}: {{ notificationsToDisplay.RefreshTime  | localTime }}</span>
                      </div>
                    </footer>
                  }
                </div>
              }
            </li>
          </div>
        }
        <!-- Message Center -->

        <!-- User Account -->
        <li class="dropdown user-menu">
          @if (user) {
            <button href="#" class="dropdown-toggle nav-link" data-bs-toggle="dropdown" id="user-profile-dropdown">
              @if (this.user.ProfileImage) {
                <img [src]="this.user.ProfileImage" class="user-image rounded-circle" alt="User Image" />
              }
              <span class="d-none d-lg-inline-block">{{ this.user.Fullname }}</span>
            </button>
          }
          <ul class="dropdown-menu dropdown-menu-end clickable">
            <!-- User image -->

            @if (showGoToProfile) {
              <li class="dropdown-menu__item">
                <a class="dropdown-link-item" (click)="goToProfile()">
                  <i class="mdi mdi-account-outline"></i>
                  <span class="nav-text">{{'T4.PAGE-HEADER.MYPROFILE' | translate}}</span>
                </a>
              </li>
            }

            @if (ticketTriggerEnabled) {
              <li class="dropdown-menu__item">
                <a class="dropdown-link-item" (click)="openTicketTrigger()">
                  <i class="tickettrigger"></i>
                  <span class="nav-text">{{'T4.PAGE-HEADER.GO-TO-TICKETTRIGGER' | translate}}</span>
                </a>
              </li>
            }

            @for (channel of selectableChannels; track channel; let isFirst = $first; let isLast = $last) {
              <li
                [ngClass]="{'dropdown-menu__item--small-first': isFirst, 'dropdown-menu__item--small-last': isLast}">
                <a class="dropdown-link-item" (click)="setChannel(channel.SalesChannelId)">
                  <i class="mdi mdi-account-outline"></i>
                  <span class="nav-text">{{ channel.Name | excerpt:25}}</span>
                </a>
              </li>
            }

            <li class="dropdown-menu__item dropdown-menu__item--last clickable">
              <a class="dropdown-link-item" (click)="logOff()"><i class="mdi mdi-logout"></i>
              <span class="nav-text">{{'BTN.LOGOFF' | translate}}</span>
            </a>
          </li>

        </ul>
      </li>

    </ul>
  </div>
</nav>


</header>




<nav aria-label="breadcrumb">
  <ol class="breadcrumb slim-breadcrumb">
    @for (bc of breadCrumbs; track bc; let last = $last) {
      <li class="breadcrumb-item" [class.active]="last">
        @if (last === true || bc.noNavigate) {
          @if (bc.isHome) {
            <i
            class="fas fa-home"></i>
            }{{bc.label | translate}}
          } @else {
            <a [routerLink]="bc.url">@if (bc.isHome) {
              <i class="fas fa-home"></i>
            }{{bc.label | translate}}</a>
          }
        </li>
      }
    </ol>
  </nav>
